import React, { useEffect, useState } from "react";
import { useLaunchDarklyFlag } from "@lululemon/mwa-launch-darkly";
import { publicConfig } from "../../util/public-config";
import { useCdpSeoDataService } from "@lululemon/ecom-site/src/util/with-cdp-seo-data-service";

const STYLE = {
  position: "fixed",
  bottom: 23,
  left: 0,
  padding: 4,
  fontSize: 12,
  background: "#000",
  color: "#fff",
  borderRadius: 2,
  margin: 4,
  fontWeight: "bold",
  zIndex: 999,
};

/**
 * @description Renders a badge to indicate that the CDP API is being used if the custom header is present and the LD flag is enabled
 * @returns {JSX.Element}
 */
export const CdpSeoDataServiceIndicator = () => {
  const { isCdpSeoDataServiceEnabled } = useCdpSeoDataService();
  const layoutCdpSeoDataServiceLDFlag = useLaunchDarklyFlag(
    "layout-cdp-seo-data-service-badge",
    false,
    publicConfig?.launchDarkly?.clientSideId
  );
  const [showIndicator, setShowIndicator] = useState(false);

  // The useEffect is utilized to prevent the indicator from rendering on SSRs to avoid inadvertent caching on Akamai
  useEffect(() => {
    if (isCdpSeoDataServiceEnabled && layoutCdpSeoDataServiceLDFlag) {
      setShowIndicator(true);
    }
  }, [isCdpSeoDataServiceEnabled, layoutCdpSeoDataServiceLDFlag]);

  return (
    <>
      {showIndicator && (
        <div id="cdp-seo-data-service-indicator" style={STYLE}>
          CDP SEO Data Service
        </div>
      )}
    </>
  );
};
